import type { StatsPeriod } from '@/types/dmAutomation';

export const queryKeys = {
    instagram: {
        all: ['instagram'] as const,
        status: (withProfile: boolean) => ['instagram', 'status', { withProfile }] as const,
        media: (limit: number) => ['instagram', 'media', 'list', { limit }] as const,
        mediaByIds: (ids: string[]) => ['instagram', 'media', 'by-ids', [...ids].sort()] as const,
    },
    dmAutomation: {
        all: ['dm-automation'] as const,
        list: () => ['dm-automation', 'list'] as const,
        limit: () => ['dm-automation', 'limit'] as const,
        usage: () => ['dm-automation', 'usage'] as const,
        verification: () => ['dm-automation', 'verification'] as const,
        statsOverview: () => ['dm-automation', 'stats', 'overview'] as const,
        stats: (id: string, period: StatsPeriod) => ['dm-automation', id, 'stats', period] as const,
        logs: (id: string, page: number, limit: number) =>
            ['dm-automation', id, 'logs', { page, limit }] as const,
    },
    carousel: {
        all: ['carousel'] as const,
        cutDesigns: (cutType: string) => ['carousel', 'cut-designs', { cutType }] as const,
        results: (offset: number, limit: number) => ['carousel', 'results', { offset, limit }] as const,
    },
    caricature: {
        all: ['caricature'] as const,
        styles: () => ['caricature', 'styles'] as const,
        list: (offset: number, limit: number) => ['caricature', 'list', { offset, limit }] as const,
    },
} as const;
